import { SidebarState } from '../slices/userSettings';
import useUserSettingsSelector from './useUserSettingsSelector';

const useQuickAccessDictionaryViewState = () => {
  const { sidebarState } = useUserSettingsSelector('sidebarState');
  return sidebarState === SidebarState.Dictionary;
};

export default useQuickAccessDictionaryViewState;
